<div class="multi-select"
  [class.multi-select--filtro]="variante === 'filtro'"
  [class.multi-select--has-value]="selectedTotalOptions > 0"
  [class.multi-select--open]="isOpen"
>
  <div
    class="multi-select__input"
    #inputRef
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="!disabled && open()"
  >
    <span class="multi-select__input-icon" *ngIf="exibirIcone" aria-hidden="true">
      <i class="fas" [ngClass]="icon"></i>
    </span>

    <input
      type="text"
      readonly
      [placeholder]="customPlaceholder || settings?.placeholder"
      [disabled]="disabled"
    />

    <span
      class="multi-select__clear"
      [class.multi-select__clear--disabled]="disabled"
      *ngIf="selectedTotalOptions > 0"
    >
      <span class="badge badge-primary badge-pill">
        {{ selectedTotalOptions }}
        <i
          class="fas fa-times"
          (click)="!disabled && clear(); $event.stopPropagation()"
        ></i>
      </span>
    </span>

    <span class="multi-select__input-indicator">
      <i
        class="fas"
        [ngClass]="{
          'fa-chevron-up': isOpen,
          'fa-chevron-down': !isOpen
        }"
      ></i>
    </span>
  </div>

</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayPanelClass]="overlayPanelClasses"
  (overlayOutsideClick)="onOverlayOutsideClick($event)"
  (detach)="onOverlayDetach()"
>
  <div
    class="multi-select__dropdown"
    [class.multi-select__dropdown--com-rodape]="settings?.showFooter"
    [style.--largura-do-trigger.px]="larguraDoTrigger"
    [style.--altura-maxima-dropdown.px]="overlayMaxHeight">
    <ng-container *ngIf="!settings?.isLoading">
      <div class="multi-select__filter" *ngIf="settings?.hasSearchField">
        <i class="fas fa-search multi-select__filter-icon"></i>
        <input
          type="text"
          [(ngModel)]="searchText"
          (input)="onSearch()"
          placeholder="Pesquisar..."
        />
        <button
          *ngIf="searchText"
          type="button"
          (click)="clearSearchFilter($event)"
          class="multi-select__filter-clear"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
      <ul
        class="multi-select__options multi-select__options--cabecalho"
        *ngIf="filteredOptions?.length"
      >
        <li
          (click)="selectAllOptions($event)"
          class="multi-select__select-all"
        >
          <input
            class="multi-select__checkbox"
            type="checkbox"
            [checked]="todasVisiveisSelecionadas"
            [indeterminate]="selecaoVisivelParcial"
            tabindex="-1"
          />
          <span>{{ selectAllLabel }}</span>
          <span class="multi-select__select-all-count">
            {{ selectedVisibleOptions }}/{{ totalVisibleOptions }}
          </span>
        </li>
      </ul>
      <ul class="multi-select__options" #optionsList>
        <ng-container
          *ngIf="filteredOptions && filteredOptions?.length; else noOptions"
        >
          <li
            *ngFor="let option of filteredOptions; trackBy: trackByOptionId"
            (click)="selectOption(option, $event)"
            class="multi-select__option"
            title="{{ option.label }}"
            [ngClass]="option.cssClass"
          >
            <input
              class="multi-select__checkbox"
              type="checkbox"
              [checked]="option.isChecked"
              (change)="selectOption(option, $event)"
            />
            <ng-container *ngIf="customOptionTemplate; else defaultLabel">
              <ng-container
                *ngTemplateOutlet="
                  customOptionTemplate;
                  context: { $implicit: option }
                ">
              </ng-container>
            </ng-container>
            <ng-template #defaultLabel>
              <span class="multi-select__option-label">{{ option.label }}</span>
            </ng-template>
          </li>
        </ng-container>

        <ng-template #noOptions>
          <div class="multi-select__options--empty">
            <span>{{ settings?.searchEmptyResultMessage }}</span>
          </div>
        </ng-template>
      </ul>
    </ng-container>

    <ng-container *ngIf="settings?.isLoading">
      <div class="multi-select__loading">
        <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
        <span>Carregando...</span>
      </div>
    </ng-container>

    <div class="multi-select__footer" *ngIf="settings?.showFooter">
      <button
        class="btn btn-outline-secondary"
        [disabled]="semDados"
        (click)="clear()"
      >
        Limpar
      </button>
      <button class="btn btn-primary" [disabled]="semDados" (click)="filter()">
        Filtrar
      </button>
    </div>
  </div>
</ng-template>
